export default __webpack_public_path__ + "static/media/seatsIcon.ff66d5f5.png";